// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gMwAd04JA9b_bj {\n  color: var(--ds-icon-inverse, #FFFFFF);\n}\n.BppQGb2j7TfyB5 {\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 3px;\n  clear: both;\n  display: block;\n  float: left;\n  margin: 0 0 4px 8px;\n  text-decoration: none;\n  transition: transform 85ms ease-in;\n  color: #c7d1db;\n  padding: 6px 12px 6px 10px;\n}\n.BppQGb2j7TfyB5:hover {\n  background: rgba(0, 0, 0, 0.8);\n  color: #FFFFFF;\n  transform: translateX(5px);\n}\n.Og0RaHLc_d_m0n {\n  margin-left: 6px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "gMwAd04JA9b_bj",
	"button": "BppQGb2j7TfyB5",
	"buttonLabel": "Og0RaHLc_d_m0n"
};
export default ___CSS_LOADER_EXPORT___;
